module.exports = __webpack_public_path__ + "img/antes_despues_103.ebe0811f.png";